/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_BadgeInputs */

const et_difference_badge = /** @type {(inputs: Difference_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enne / Pärast`)
};

const en_difference_badge = /** @type {(inputs: Difference_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before / After`)
};

/**
* | output |
* | --- |
* | "Before / After" |
*
* @param {Difference_BadgeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_badge = /** @type {((inputs?: Difference_BadgeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_BadgeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_badge(inputs)
	return en_difference_badge(inputs)
});